import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente ModalBox
 */
export const ModalBox = styled.div`
  background: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #000;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 6px;
  padding: 40px;
  box-sizing: border-box;
  outline: 0;
  padding-top: 20px;
  /* padding-bottom: 90px; */
  padding-bottom: 30px;
  min-width: 250px;
  max-width: 80vw;

  header {
    border-bottom: 1px solid #e6e6e6;

    h2 {
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 41px;
    }
  }

  footer {    
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: ${({ optionDontShowAlertAgain }) => (optionDontShowAlertAgain ? 'space-between' : 'flex-end')};
    
    .dont-show-again {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: #5e6366;
    }
  }

  p {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    margin-top: 27px;
    color: #5e6366;
    white-space: normal;
    /* word-break: break-all; */
    word-break: break-word;
  }

  .close {
    background: none;
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
  }
`;

/**
 * Estilização do componente StyledButton
 */
export const StyledButton = styled(Button)`
  &.MuiButton-root {
    text-transform: none;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    padding: 8px 20px;
    min-width: 104px;
  }

  &.MuiButton-contained {
    box-shadow: none;
  }

  &.MuiButton-containedPrimary {
    color: #fff;
    background-color: #3c71dd;
    top: 10px;
  }
`;

/**
 * Estilização do componente StyledCheckbox
 */
export const StyledCheckbox = styled(Checkbox)`
  &.MuiCheckbox-colorPrimary.Mui-checked {
    color: #3c71dd;
  }

  .MuiSvgIcon-fontSizeSmall {
    font-size: 1rem;
  }
`;
